import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        default:
          'bg-blue-600 text-white shadow hover:bg-blue-500 active:scale-95',
        destructive:
          'bg-red-600 text-white shadow hover:bg-red-500 active:scale-95',
        outline:
          'border border-slate-700 bg-transparent text-slate-200 shadow-sm hover:bg-slate-800 hover:text-white active:scale-95',
        secondary:
          'bg-slate-800 text-slate-200 shadow-sm hover:bg-slate-700 active:scale-95',
        ghost:
          'hover:bg-slate-800 hover:text-white text-slate-400 active:scale-95',
        link:
          'text-blue-400 underline-offset-4 hover:underline',
        success:
          'bg-emerald-600 text-white shadow hover:bg-emerald-500 active:scale-95',
      },
      size: {
        default: 'h-9 px-4 py-2',
        sm: 'h-8 rounded-md px-3 text-xs',
        lg: 'h-10 rounded-lg px-6',
        icon: 'h-9 w-9',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : 'button';
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props}
    />
  );
});
Button.displayName = 'Button';

export { Button, buttonVariants };
